import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export enum ConfirmAcceptanceViewStages {
  HIGH_LEVEL_DETAILS_VIEW = 'HIGH_LEVEL_DETAILS_VIEW',
  FIRST_AVAILABLE_DATE_VIEW = 'FIRST_AVAILABLE_DATE_VIEW',
  ACCEPTANCE_DECISION_VIEW = 'ACCEPTANCE_DECISION_VIEW',
}

export const useViewRouter = (initialStage = ConfirmAcceptanceViewStages.HIGH_LEVEL_DETAILS_VIEW) => {
  const [currentViewToShow, setCurrentViewToShow] = useState<ConfirmAcceptanceViewStages>(initialStage);
  const navigate = useNavigate();

  const goToHighLevelDetails = () => setCurrentViewToShow(ConfirmAcceptanceViewStages.HIGH_LEVEL_DETAILS_VIEW);
  const goToFirstAvailableDate = () => setCurrentViewToShow(ConfirmAcceptanceViewStages.FIRST_AVAILABLE_DATE_VIEW);
  const goToAcceptanceDecision = () => setCurrentViewToShow(ConfirmAcceptanceViewStages.ACCEPTANCE_DECISION_VIEW);

  const handleBackClick = () => {
    switch (currentViewToShow) {
      case ConfirmAcceptanceViewStages.FIRST_AVAILABLE_DATE_VIEW:
        goToHighLevelDetails();
        break;
      case ConfirmAcceptanceViewStages.ACCEPTANCE_DECISION_VIEW:
      case ConfirmAcceptanceViewStages.HIGH_LEVEL_DETAILS_VIEW:
      default:
        return navigate(-1);
    }
  };

  return {
    currentViewToShow,
    goToHighLevelDetails,
    goToFirstAvailableDate,
    goToAcceptanceDecision,
    handleBackClick,
  };
};
